import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { MenuItem, TextField } from '@material-ui/core';
import { useEffect } from 'react';
import '../ticketKnowledge/DrilldownAndDetailSearch.css';
import _ from 'lodash';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function SettingChatPermissionForm({ props, argsAll }) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    const knowledgeTicketChatPermissions = Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT;

    const onChangeSelectedChatPermission = event => {
        let chatPermissionValue = event.target.value;
        argsAll.setSelectedChatPermissions(chatPermissionValue);
        if (chatPermissionValue.length > 0) {
            argsAll.setIsChangeData(true);
        } else {
            argsAll.setIsChangeData(false);
        }
    };

    useEffect(() => {
        if (argsAll.formEdit) {
            argsAll.setSelectedChatPermissions(
                knowledgeTicketChatPermissions[argsAll.formEdit.chatPermission]
            );
        }
    }, []);

    return (
        <>
            <div className="lstCreateForm padding-0">
                <label className="share-option-text">{tr('基本権限')}</label>
                <div className="share-option-control">
                    <TextField
                        name="share-option"
                        className="form-control--wrap form-control--hg32"
                        select
                        variant="outlined"
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                        value={argsAll.selectedChatPermissions}
                        onChange={onChangeSelectedChatPermission}
                        defaultValue={
                            argsAll.formEdit && argsAll.formEdit?.chatPermission
                                ? argsAll.formEdit.chatPermission
                                : Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT
                        }
                        disabled={argsAll.isFormReadOnly}
                    >
                        {!Utils.isEmptyArray(argsAll.listOptionChatPermission) &&
                            argsAll.listOptionChatPermission?.map((item, i) => {
                                return (
                                    <MenuItem key={i} value={item}>
                                        {tr(item)}
                                    </MenuItem>
                                );
                            })}
                    </TextField>
                </div>
            </div>
        </>
    );
}
